import { WEBUILogs } from "../logging";

export default function(date) {
    if (!date) {
        WEBUILogs.error("isWeekday: Not supplied date!");
    }
    let workDate = new Date(date);
    return !(workDate.getDay() === 6 || workDate.getDay() === 0);
}
